<template>
  <el-dialog
    :title="title"
    :visible.sync="visibleSync"
    width="520px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="140px">
      <el-form-item label="野外编号" prop="fieldNo">
        <el-select
          v-model="form.fieldNo"
          filterable
          allow-create
          default-first-option
          placeholder="请选择或输入野外编号"
          style="width: 100%;"
          :disabled="!!form.id"
          @change="handleFieldNoChange"
        >
          <el-option
            v-for="item in spotOptions"
            :key="item.id"
            :label="item.fieldNo + ' - ' + item.name"
            :value="item.fieldNo"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称" :disabled="!!form.id"></el-input>
      </el-form-item>
      <el-form-item label="乡镇/街道" prop="township">
        <el-select v-model="form.township" placeholder="请选择" style="width: 100%;" :disabled="!!form.id">
          <el-option v-for="item in townshipList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="监测类型" prop="monitorType">
        <el-select v-model="form.monitorType" placeholder="请选择监测类型" style="width: 100%;" :disabled="!!form.id" @change="handleTypeChange">
          <el-option
            v-for="item in monitorTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="年份" prop="year">
        <el-input v-model="form.year" maxlength="4" placeholder="请输入年份，如2024" :disabled="!!form.id" @blur="handleYearChange"></el-input>
      </el-form-item>
      <el-form-item label="阶段" prop="stageId">
        <el-select v-model="form.stageId" placeholder="请选择阶段" style="width: 100%;" :disabled="!stageList.length || !!form.id">
          <el-option
            v-for="item in stageList"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          ></el-option>
        </el-select>
        <div v-if="!stageList.length && form.spotId && form.year" style="color: #909399; font-size: 12px; margin-top: 4px;">
          该图斑在 {{ form.year }} 年暂无阶段，保存任务时将自动创建。
        </div>
      </el-form-item>

      <!-- 联动字段 -->
      <el-form-item label="土壤质量达标率(%)" prop="soilQualityRate" v-if="form.monitorType == '土壤监测'">
        <el-input-number v-model="form.soilQualityRate" :min="0" :max="100" :precision="2" style="width: 200px;"></el-input-number>
      </el-form-item>
      <el-form-item label="水量质量达标率(%)" prop="waterQualityRate" v-if="form.monitorType == '水样监测'">
        <el-input-number v-model="form.waterQualityRate" :min="0" :max="100" :precision="2" style="width: 200px;"></el-input-number>
      </el-form-item>
      <template v-if="form.monitorType == '复绿植被成活率监测'">
        <el-form-item label="植被成活率(%)" prop="vegetationSurvivalRate">
          <el-input-number v-model="form.vegetationSurvivalRate" :min="0" :max="100" :precision="2" style="width: 200px;"></el-input-number>
        </el-form-item>
        <el-form-item label="植被成活数(株)" prop="vegetationSurvivalCount">
          <el-input-number v-model="form.vegetationSurvivalCount" :min="0" :precision="0" style="width: 200px;"></el-input-number>
        </el-form-item>
      </template>
      <template v-if="form.monitorType == '植被覆盖率监测'">
        <el-form-item label="植物覆盖率(%)" prop="vegetationCoverage">
          <el-input-number v-model="form.vegetationCoverage" :min="0" :max="100" :precision="2" style="width: 200px;"></el-input-number>
        </el-form-item>
        <el-form-item label="修复面积(平方米)" prop="repairArea">
          <el-input-number v-model="form.repairArea" :min="0" :precision="2" style="width: 200px;"></el-input-number>
        </el-form-item>
      </template>

      <!-- 创建/修改信息在列表中展示，此处不显示 -->
    </el-form>
    <span slot="footer">
      <el-button @click="visibleSync = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      townshipList: [],
      spotOptions: [],
      stageList: [],
      monitorTypeList: [
        { label: "危岩体稳定性监测", value: "危岩体稳定性监测" },
        { label: "变形监测", value: "变形监测" },
        { label: "复绿植被成活率监测", value: "复绿植被成活率监测" },
        { label: "植被监测", value: "植被监测" },
        { label: "土壤监测", value: "土壤监测" },
        { label: "水样监测", value: "水样监测" },
        { label: "植被覆盖率监测", value: "植被覆盖率监测" }
      ],
      form: {
        id: null,
        spotId: null,
        fieldNo: "",
        name: "",
        township: "",
        monitorType: "",
        year: new Date().getFullYear().toString(),
        stageId: null,
        soilQualityRate: null,
        waterQualityRate: null,
        vegetationCoverage: null,
        vegetationSurvivalRate: null,
        vegetationSurvivalCount: null,
        repairArea: null
      },
      rules: {
        fieldNo: [{ required: true, message: "请输入野外编号", trigger: "blur" }],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        township: [{ required: true, message: "请选择乡镇/街道", trigger: "change" }],
        monitorType: [{ required: true, message: "请选择监测类型", trigger: "change" }],
        year: [
          { required: true, message: "请输入年份", trigger: "blur" },
          { pattern: /^\d{4}$/, message: "年份格式不正确", trigger: "blur" }
        ],
        stageId: []
      }
    };
  },
  computed: {
    visibleSync: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    title() {
      return this.form.id ? "编辑监测任务" : "新建监测任务";
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
        this.loadTownships();
        this.loadSpots();
      }
    }
  },
  methods: {
    initForm() {
      this.stageList = [];
      if (this.data) {
        this.form = {
          id: this.data.id,
          spotId: this.data.spotId,
          fieldNo: this.data.fieldNo || "",
          name: this.data.spotName || "",
          township: this.data.township || "",
          monitorType: this.data.monitorType || "",
          year: this.data.year ? String(this.data.year) : new Date().getFullYear().toString(),
          stageId: this.data.stageId || null,
          soilQualityRate: this.data.soilQualityRate != null ? Number(this.data.soilQualityRate) : (this.data.soilRate != null ? Number(this.data.soilRate) : null),
          waterQualityRate: this.data.waterQualityRate != null ? Number(this.data.waterQualityRate) : (this.data.waterRate != null ? Number(this.data.waterRate) : null),
          vegetationCoverage: this.data.vegetationCoverage != null ? Number(this.data.vegetationCoverage) : (this.data.coverageRate != null ? Number(this.data.coverageRate) : null),
          vegetationSurvivalRate: this.data.vegetationSurvivalRate != null ? Number(this.data.vegetationSurvivalRate) : (this.data.survivalRate != null ? Number(this.data.survivalRate) : null),
          vegetationSurvivalCount: this.data.vegetationSurvivalCount != null ? Number(this.data.vegetationSurvivalCount) : (this.data.survivalCount != null ? Number(this.data.survivalCount) : null),
          repairArea: this.data.repairArea != null ? Number(this.data.repairArea) : (this.data.repairArea != null ? Number(this.data.repairArea) : null),
        };
        if (this.form.spotId && this.form.year) {
          this.loadStageList();
        }
      } else {
        this.form = {
          id: null,
          spotId: null,
          fieldNo: "",
          name: "",
          township: "",
          monitorType: "",
          year: new Date().getFullYear().toString(),
          stageId: null,
          soilQualityRate: null,
          waterQualityRate: null,
          vegetationCoverage: null,
          vegetationSurvivalRate: null,
          vegetationSurvivalCount: null,
          repairArea: null
        };
      }
    },
    loadTownships() {
      this.$apis.get("/admin/dashboard/township/list").then(res => {
        if (res.data.code == 200) {
          this.townshipList = res.data.data || [];
        }
      });
    },
    loadSpots() {
      this.$apis.get("/admin/spot/list").then(res => {
        if (res.data.code == 200) {
          this.spotOptions = res.data.data || [];
        }
      });
    },
    handleFieldNoChange(val) {
      if (!val) {
        this.form.spotId = null;
        return;
      }
      const found = this.spotOptions.find(item => item.fieldNo === val);
      if (found) {
        this.form.spotId = found.id;
        this.form.name = found.name;
        this.form.township = found.township || "";
        this.handleYearChange();
      } else {
        // 用户手动输入了新编号，只清空关联的spotId，保留输入的名称和乡镇
        this.form.spotId = null;
      }
    },
    handleYearChange() {
      if (this.form.spotId && /^\d{4}$/.test(this.form.year)) {
        this.loadStageList();
      }
    },
    loadStageList() {
      if (!this.form.spotId || !this.form.year) return;
      this.$apis.get("/admin/spot/stage/list", { spotId: this.form.spotId, year: this.form.year }).then(res => {
        if (res.data.code == 200) {
          this.stageList = res.data.data || [];
          // 编辑时如果stageId不在列表中，清空选择
          if (this.form.stageId && !this.stageList.find(s => s.id === this.form.stageId)) {
            this.form.stageId = null;
          }
        } else {
          this.$message.error(res.data.msg || "阶段列表加载失败");
        }
      }).catch(err => {
        console.error("loadStageList error", err);
        this.$message.error("阶段列表加载失败，请检查网络或后端服务");
      });
    },
    handleTypeChange() {
      this.form.soilQualityRate = null;
      this.form.waterQualityRate = null;
      this.form.vegetationCoverage = null;
      this.form.vegetationSurvivalRate = null;
      this.form.vegetationSurvivalCount = null;
      this.form.repairArea = null;
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        const params = {
          id: this.form.id,
          spotId: this.form.spotId,
          fieldNo: this.form.fieldNo,
          name: this.form.name,
          township: this.form.township,
          monitorType: this.form.monitorType,
          year: this.form.year,
          stageId: this.form.stageId
        };
        if (this.form.monitorType === "土壤监测" && this.form.soilQualityRate != null) {
          params.soilQualityRate = this.form.soilQualityRate;
        }
        if (this.form.monitorType === "水样监测" && this.form.waterQualityRate != null) {
          params.waterQualityRate = this.form.waterQualityRate;
        }
        if (this.form.monitorType === "复绿植被成活率监测") {
          if (this.form.vegetationSurvivalRate != null) params.vegetationSurvivalRate = this.form.vegetationSurvivalRate;
          if (this.form.vegetationSurvivalCount != null) params.vegetationSurvivalCount = this.form.vegetationSurvivalCount;
        }
        if (this.form.monitorType === "植被覆盖率监测") {
          if (this.form.vegetationCoverage != null) params.vegetationCoverage = this.form.vegetationCoverage;
          if (this.form.repairArea != null) params.repairArea = this.form.repairArea;
        }
        this.$apis.post("/admin/spotTask/saveOrUpdate", params).then(res => {
          if (res.data && res.data.code == 200) {
            this.$message.success("保存成功");
            this.visibleSync = false;
            this.$emit("success");
          } else {
            let msg = "";
            if (res.data) {
              msg = res.data.msg || res.data.message || res.data.data;
              if (!msg && typeof res.data === "string") {
                msg = res.data;
              }
            }
            this.$message.error(msg || "保存失败");
          }
        }).catch(err => {
          let msg = "保存失败";
          if (err && err.response) {
            const data = err.response.data;
            if (data) {
              msg = data.msg || data.message || data.data || (typeof data === "string" ? data : msg);
            }
          }
          this.$message.error(msg);
        });
      });
    },
    handleClose() {
      this.$refs.form.resetFields();
      this.stageList = [];
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/components/addSpotTask.vue